
import React, { useEffect, useState, useRef } from "react";
import { API_KEY, API_SECRET, SDK_URL } from "constantes/constantes";

export default function PlayerOVP({ session_id, event_unit }) {

    const [isDomainAllowed, setIsDomainAllowed] = useState(true);

    // console.log("valores de llaves ==> session_id: ", session_id, ", event_unit: ", event_unit, " hotsname: ", window.location.hostname);
    // dev-cdn.clarosports.com

    // valida que el dominio pertenezca a clarosports
    useEffect(() => {
        const domain = window.location.hostname;
        // const allowedDomains = ["clarosports", "localhost"];
        // const isAllowed = allowedDomains.includes(domain);
        const isAllowed = domain.includes("clarosports") || domain.includes("localhost");

        setIsDomainAllowed(isAllowed);
      }, []);

    useEffect(() => {
        // El script se ejecutará una vez que el componente se haya montado en el DOM.
        (function (o, l, y, m, p, i, c, s) {
            o.__OvpSdkObject = p; o[p] = o[p] || {}; o[p].ready = function (f) {
                (o[p].q = o[p].q || []).push(f)
            }; o[p].r = m; o[p].o = i; c = l.createElement(y); c.async = 1; c.src = m;
            s = l.getElementsByTagName(y)[0]; s.parentNode.insertBefore(c, s)
        })(window, document, 'script', SDK_URL, 'OVP', {
            apiKey: API_KEY,
            apiSecret: API_SECRET,
            lang: 'es-ES',
            dir: 'ltr'
        });

        // La función de retorno de useEffect se usará para limpiar el efecto si es necesario.
        return () => {
            // Por ejemplo, si el script cargado necesita ser eliminado del DOM.
            // Esto puede no ser necesario para todos los scripts. En ese caso, puedes dejar esta parte fuera.
            const scriptElement = document.querySelector('script[src=' + SDK_URL + ']');
            if (scriptElement) {
                scriptElement.remove();
            }
        };
    }, []);

    useEffect(() => {
        // Esperar a que el SDK esté listo antes de ejecutar el código
        if (window.OVP) {
            window.OVP.ready(function () {
                // Obtener el elemento contenedor por su id
                const wrapperElementResults = document.getElementById('element-player');

                // Verificar si se encontró el elemento contenedor
                if (wrapperElementResults) {
                    // Agregar el widget al elemento contenedor
                    window.OVP.widgets
                        .addWidget({
                            type: "player-embed",
                            root: wrapperElementResults,
                            config:
                            {
                                scheduleSessionId: session_id,
                                eventUnitId: event_unit,
                                autoplay: false,
                                enablePictureInPicture: true,
                                enableChromecast: true,
                                enableAirplay: true,
                                enableFullscreen: true,
                                // showHighlightExplorer: true,
                                // showChapters: true,
                                // showMoments: true,
                                // showThumbnail: true,
                                // showEndScreenCta: false,
                                // showPauseOverlay: true,
                                // showLogo: true,
                                // showFieldsOfPlay: false
                            }
                        })
                        .then(function ([widgetController]) {
                            // widgetController
                            console.log(widgetController);
                        });
                }
                // Listen for event that the player embed changes presentation mode
                window.OVP.addEventListener('playerembedpresentationmodechange', (event) => {
                    // we only care about the scenario where the native fullscreen API is not supported
                    if (!event.isNativeFullScreenApiSupported) {
                    if (event.presentationMode === 'fullscreen') {
                        // if we switch to full screen, tell the parent window to go fullscreen
                        window.parent.postMessage({ type: 'enter-fullscreen' }, '*');
                    } else {
                        // otherwise we want to exit fullscreen
                        window.parent.postMessage({ type: 'exit-fullscreen' }, '*');
                    }
                    }
                });
                window.OVP.config.setTheme({
                    font: 'noto-sans',
                    inverted: false,
                    colors: {
                        "base": {
                            normal: "#772727",
                            inverted: "#ffffff"
                        },
                        "base-light": {
                            normal: "#772727",
                            inverted: "#e1e7f0"
                        },
                        "base-extra-light": {
                            normal: "#ffffff",
                            inverted: "#fefeff"
                        },
                        "active": {
                            normal: "#973b3b",
                            inverted: "#ffffff"
                        },
                        "sport": {
                            normal: "#a36921",
                            inverted: "#b77625"
                        },
                        "link": {
                            normal: "#333333",
                            inverted: "#93C4FF"
                        },
                        "live": {
                            normal: "#74b259",
                            inverted: "#e0002d"
                        },
                        "container-background": {
                            normal: "#480000",
                            inverted: "#ffffff"
                        },
                        "widget-background": {
                            normal: "#ffffff",
                            inverted: "#ffffff"
                        },
                        "gold-base": {
                            normal: "linear-gradient(270deg, #EABE08 0%, #F4D246 100%)",
                            inverted: "linear-gradient(270deg, #EABE08 0%, #F4D246 100%)"
                        },
                        "gold-darker": {
                            normal: "#62541C",
                            inverted: "#62541C"
                        },
                        "silver-base": {
                            normal: "linear-gradient(270deg, #BEBEBE 0%, #D1D1D1 100%)",
                            inverted: "linear-gradient(270deg, #BEBEBE 0%, #D1D1D1 100%)"
                        },
                        "silver-darker": {
                            normal: "#535353",
                            inverted: "#535353"
                        },
                        "bronze-base": {
                            normal: "linear-gradient(270deg, #B98E42 0%, #D2B169 100%)",
                            inverted: "linear-gradient(270deg, #B98E42 0%, #D2B169 100%)"
                        },
                        "bronze-darker": {
                            normal: "#342C1A",
                            inverted: "#342C1A"
                        },
                        "positive": {
                            normal: "#88c44b",
                            inverted: "#88c44b"
                        },
                        "negative": {
                            normal: "#ff0000",
                            inverted: "#ff0000"
                        },
                        "sports-data-red": {
                            normal: "#ff4a48",
                            inverted: "#ff4a48"
                        },
                        "sports-data-clear-red": {
                            normal: "#ff2725",
                            inverted: "#ff2725"
                        },
                        "sports-data-blue": {
                            normal: "#3092e1",
                            inverted: "#3092e1"
                        },
                        "sports-data-green": {
                            normal: "#0fc55d",
                            inverted: "#0fc55d"
                        },
                        "sports-data-orange": {
                            normal: "#ff781f",
                            inverted: "#ff781f"
                        },
                        "sports-data-yellow": {
                            normal: "#ffae39",
                            inverted: "#ffae39"
                        },
                        "sports-data-clear-yellow": {
                            normal: "#f3ec32",
                            inverted: "#f3ec32"
                        },
                        "sports-data-brown": {
                            normal: "#cc9966",
                            inverted: "#cc9966"
                        },
                        "sports-data-eagle": {
                            normal: "#26AB3D",
                            inverted: "#26AB3D"
                        },
                        "sports-data-birdie": {
                            normal: "#47CC5E",
                            inverted: "#47CC5E"
                        },
                        "sports-data-bogey": {
                            normal: "#FCB827",
                            inverted: "#FCB827"
                        },
                        "sports-data-worse": {
                            normal: "#FF564D",
                            inverted: "#FF564D"
                        },
                        "grey-background": {
                            normal: "#f5f6f7",
                            inverted: "#f5f6f7"
                        },
                        "grey-10": {
                            normal: "#121417",
                            inverted: "#FFFFFF"
                        },
                        "grey-09": {
                            normal: "#1D1F21",
                            inverted: "#1D1F21"
                        },
                        "grey-08": {
                            normal: "#2F3133",
                            inverted: "#2F3133"
                        },
                        "grey-07": {
                            normal: "#46484a",
                            inverted: "#e5e5e6"
                        },
                        "grey-06": {
                            normal: "#636466",
                            inverted: "#636466"
                        },
                        "grey-05": {
                            normal: "#7D7E80",
                            inverted: "#7D7E80"
                        },
                        "grey-04": {
                            normal: "#96989b",
                            inverted: "#96989b"
                        },
                        "grey-03": {
                            normal: "#ADAFB3",
                            inverted: "#ADAFB3"
                        },
                        "grey-02": {
                            normal: "#e5e5e6",
                            inverted: "#46484a"
                        },
                        "grey-01": {
                            normal: "#F5F6F7",
                            inverted: "#F5F6F7"
                        },
                        "white": {
                            normal: "#ffffff",
                            inverted: "#121417"
                        }
                    }
                });
            });
        }
    }, [session_id, event_unit]);

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const ovpRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (ovpRef.current) {
            resizeObserver.observe(ovpRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [ovpRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------



    // Si el dominio no está permitido, muestra el mensaje de sitio no autorizado
    if (!isDomainAllowed) {
        return (
            <div id="modalForbbiden" className="forbbiden">
                <h1>Sitio no autorizado</h1>
                <p className="link">Visita: <a href="https://www.clarosports.com/" target="_blank" rel="noopener noreferrer" >clarosports.com</a></p>
            </div>
        );
    }

    return (
        <>
            <div id="element-player" ref={ovpRef}></div>
        </>
    )
}